import React, { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f8f8f8;
  padding: 20px;
`;

const Card = styled.div`
  width: 100%;
  max-width: 400px;
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

const Title = styled.h2`
  font-size: 1.8rem;
  color: #333;
  font-weight: 600;
  margin-bottom: 20px;
`;

const Label = styled.label`
  font-size: 1rem;
  color: #555;
  font-weight: 500;
  margin-bottom: 8px;
  display: block;
  text-align: left;
`;

const Input = styled.input`
  width: 100%;
  padding: 12px;
  font-size: 1rem;
  color: #333;
  background-color: #f1f1f1;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 16px;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #007aff;
  }
`;

const AmountInput = styled(Input)`
  font-weight: bold;
  font-size: 1.2rem;
  color: #007aff;
  text-align: right;
`;

const PaymentButton = styled.button`
  background-color: #007aff;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  padding: 12px;
  width: 100%;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #005bb5;
  }
`;

const ConfirmationMessage = styled.div`
  margin-top: 20px;
  font-size: 1rem;
  color: #28a745;
`;

const PaymentPage = () => {
  const [upiId, setUpiId] = useState('');
  const [amount, setAmount] = useState('');
  const [confirmation, setConfirmation] = useState('');

  const handlePayment = () => {
    setConfirmation(`Payment of ₹${amount} to ${upiId} is successful!`);
    // Reset form fields
    setUpiId('');
    setAmount('');
  };

  return (
    <Container>
      <Card>
        <Title>UPI Payment</Title>
        <Label>UPI ID</Label>
        <Input 
          type="text" 
          placeholder="Enter UPI ID (e.g., name@bank)" 
          value={upiId} 
          onChange={(e) => setUpiId(e.target.value)} 
        />

        <Label>Amount</Label>
        <AmountInput 
          type="number" 
          placeholder="Enter amount" 
          value={amount} 
          onChange={(e) => setAmount(e.target.value)} 
        />

        <PaymentButton onClick={handlePayment}>Pay Now</PaymentButton>

        {confirmation && <ConfirmationMessage>{confirmation}</ConfirmationMessage>}
      </Card>
    </Container>
  );
};

export default PaymentPage;
